import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=96f79980&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f79980",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96f79980')) {
      api.createRecord('96f79980', component.options)
    } else {
      api.reload('96f79980', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=96f79980&scoped=true&", function () {
      api.rerender('96f79980', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Ib6qkiS439YT/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports